import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import AmericanFinancialsBox from "components/company/v3/american/boxes/AmericanFinancialsBox";
import { CompanyFinancialsTabEnum } from "components/company/v3/menu/enums";
import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import AmericanIssuerSeo from "components/company/v3/seo/AmericanIssuerSeo";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";
import useSelfie from "lib/hooks/useSelfie";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";

interface AmericanFinancialsPageProps {
  tickerSymbol: string | null;
}

const AmericanFinancialsPage: NextPage<AmericanFinancialsPageProps> = function AmericanFinancialsPage({
  tickerSymbol,
}) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyFinancialsTabEnum>(Object.values(CompanyFinancialsTabEnum)).withDefault(
      CompanyFinancialsTabEnum.FINANCIALS,
    ),
  );
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Stocks" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <AmericanIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Balanços",
              description: "Título da página - SEO",
              id: "XY/aB+",
            })}
            description={intl.formatMessage({
              defaultMessage:
                "Balanço patrimonial, DRE e fluxo de caixa completos e atualizados, com Lucro Líquido, Receita, EBITDA, margens, ROE e endividamento.",
              id: "N1rvCl",
              description: "Descrição da página de balanços de uma empresa - SEO",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Us}
              tickerSymbol={normalizedTickerSymbol}
              className="px-4 pb-6 xl:px-0"
              title={intl.formatMessage({ defaultMessage: "Balanços", id: "wauBuH" })}
              description={intl.formatMessage({
                defaultMessage:
                  "Tabela de balanços completa e atualizada com os principais indicadores financeiros: Lucro Líquido, Receita, EBTIDA, Margem, ROE, Dividendos",
                id: "iUnaru",
              })}
            />
          )}
          <AmericanFinancialsBox tickerSymbol={normalizedTickerSymbol} tab={tab} onChangeTab={setTab} />
        </>
      </WrapperAmplitudeCompanyTab>
    </AmericanPageLayout>
  );
};

AmericanFinancialsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default AmericanFinancialsPage;
